import { useCallback, useEffect, useState } from 'react';

export default function useBaseLocations(api, userEmail) {
  const [tree, setTree] = useState({});
  const [coords, setCoords] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const reload = useCallback(() => setRetry(current => current + 1), []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    const load = async () => {
      try {
        const response = await api.get('/base-locations');
        if (cancelled) return;
        setTree(response.data?.tree || {});
        setCoords(response.data?.coords || {});
      } catch (requestError) {
        if (!cancelled) setError('The site list could not be loaded.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [api, userEmail, retry]);

  return { tree, coords, loading, error, reload };
}
